import { gql } from "@apollo/client";

export const ADD_NAUTICAL_WALLET_TRANSACTION = gql`
    mutation AddNauticalWalletTransaction($tranxType: NTRANX_TYPE!, $userEmail: EmailAddress!, $tranx: NauticalWalletTranxInput!) {
        addNauticalWalletTransaction(tranx_type: $tranxType, user_email: $userEmail, tranx: $tranx) {
            code
            success
            message
        }
    }
`